import { useCallback, useContext, useEffect, useState } from "react";

import { QUERY_REAL_ESTATE_AGENTS } from "../../../shared-components/GQL";
import debounce from "lodash.debounce";
import { useQuery } from "@apollo/client";
import { ConfigStateContext } from "shared-components/Contexts/Configurations/context";

export const useRealEstateAgents = () => {
	const { error, loading, data } = useQuery(QUERY_REAL_ESTATE_AGENTS);
	const [search, setSearch] = useState<string>("");
	const [inmoFull, setInmoFull] = useState([]);
	const [notInmoFull, setNotInmoFull] = useState([]);
	const { country_code } = useContext(ConfigStateContext);

	const compare = (a, b) => {
		if (a.name < b.name) return -1;
		if (a.name > b.name) return 1;
		return 0;
	};

	const debouncedSave = useCallback(
		debounce(nextValue => {
			setSearch(nextValue);
		}, 500),
		[]
	);

	const handleSearch = e => {
		const { value } = e.target;
		debouncedSave(value);
	};


	useEffect(() => {
		if (search) {
			const filtered = inmob => inmob.name.toLowerCase().includes(search.toLowerCase());
			const inmobFull = data?.inmofull.filter(filtered);
			const notInmoFull = data?.notInmoFull.filter(filtered);
			if (country_code === 'CO') {
				setInmoFull([]);
				setNotInmoFull(convertToGroup([...inmobFull, ...notInmoFull]));
			} else {
				setInmoFull(inmobFull);
				setNotInmoFull(convertToGroup(notInmoFull));
			}
		} else {
			if (country_code === 'CO') {
				setInmoFull([]);
				setNotInmoFull(convertToGroup([...data?.inmofull, ...data?.notInmoFull]));
			} else {
				setInmoFull(data?.inmofull);
				setNotInmoFull(convertToGroup(data?.notInmoFull));
			}

		}
	}, [search]);

	return {
		loading,
		error,
		data: { inmoFull, notInmoFull },
		handleSearch,
		compare,
	};
};

const convertToGroup = data => {
	const letterGroups = [
		{
			id: "# - A - F",
			startChar: "A",
			endChar: "F",
		},
		{ id: "G - K", startChar: "G", endChar: "K" },
		{ id: "L - O", startChar: "L", endChar: "O" },
		{ id: "P - T", startChar: "P", endChar: "T" },
		{ id: "U - Z", startChar: "U", endChar: "Z" },
	];

	const res = data?.reduce((acc, inmob) => {
		const firstLetterCode = inmob.name
			.charAt(0)
			.toUpperCase()
			.charCodeAt();
		const group = letterGroups.find(
			range =>
				range.startChar.charCodeAt(0) <= firstLetterCode &&
				firstLetterCode <= range.endChar.charCodeAt(0)
		);
		const key = group ? group.id : "# - A - F";
		if (!acc[key]) acc[key] = [];
		acc[key].push(inmob);
		return acc;
	}, {});

	return res;
};
